import React from 'react';
import TableLineMenu from './TableLineMenu';
import type { useTableEditor } from './useTableEditor';

type Editor = ReturnType<typeof useTableEditor>;

/** The top gutter row of per-column option menus. */
export default function TableColumnGutter({ editor }: { editor: Editor }) {
  return (
    <tr>
      <td style={{ width: 28 }} />
      {Array.from({ length: editor.columnCount }).map((_, c) => (
        <td key={c} style={{ textAlign: 'center', padding: 0 }}>
          <TableLineMenu
            orientation="column"
            index={c}
            canDelete={editor.columnCount > 1}
            onInsertBefore={() => editor.addColumn(c)}
            onInsertAfter={() => editor.addColumn(c + 1)}
            onDelete={() => editor.removeColumn(c)}
          />
        </td>
      ))}
    </tr>
  );
}
